// extracted by mini-css-extract-plugin
export default {"BackButton":"styles_BackButton__PfKAQ","BackButtonControl":"styles_BackButtonControl__6Jvbt","BackButtonText":"styles_BackButtonText__SV1Yg"};